<template>
    <v-container fluid grid-list-md>
        <v-layout wrap>
            <v-flex xs12>
                <h3>{{formTitle}}</h3>
            </v-flex>
            <v-flex xs12>
                <v-tabs
                        v-model="tab"
                >
                    <v-tab href="#tab-1">
                        Основные данные
                    </v-tab>
                    <v-tab-item
                            :value="'tab-1'">
                        <v-card

                        >
                            <v-card-text>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <v-flex xs12 sm8>
                                            <v-text-field
                                                    v-model.trim="charge.totalAmount"
                                                    type="number"
                                                    label="Сумма начисления"
                                                    :error-messages="requiredErrors('totalAmount')"
                                                    @blur="$v.charge.totalAmount.$touch()"
                                                    :disabled="this.charge.charge_condition!=1"
                                            ></v-text-field>
                                        </v-flex>
<!--                                        <v-flex xs12 sm8>-->
<!--                                            <v-text-field-->
<!--                                                    v-model.trim="charge.purpose"-->
<!--                                                    type="text"-->
<!--                                                    label="Назначение платежа"-->
<!--                                                    :error-messages="requiredErrors('purpose')"-->
<!--                                                    @blur="$v.charge.purpose.$touch()"-->
<!--                                                    :disabled="this.charge.charge_condition!=1"-->
<!--                                            ></v-text-field>-->
<!--                                        </v-flex>-->
                                        <v-flex xs12>
                                            <v-autocomplete
                                                    v-bind:items="chargeStatuses"
                                                    item-text="status"
                                                    item-value="id"
                                                    v-model="charge.charge_status"
                                                    label="Статус начисления"
                                                    :loading="listLoading.includes('gis_gmpFetchChargeStatuses')"
                                                    :disabled="this.charge.charge_condition!=1"
                                            >
                                            </v-autocomplete>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-autocomplete
                                                    :items="kbk"
                                                    item-text="fullCaption"
                                                    item-value="id"
                                                    v-model="charge.kbk"
                                                    label="КБК"
                                                    :loading="listLoading.includes('gis_gmpFetchKBK')"
                                                    :disabled="this.charge.charge_condition!=1"
                                            >
                                                <template v-slot:selection="data">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on }">
                                                            <div
                                                                    v-on="on"
                                                            >
                                                                <i>{{ data.item.name }}, {{ data.item.koap_item }}</i>
                                                            </div>
                                                        </template>
                                                        <span>№: <i>{{ data.item.id }}</i>
                                                                <br>
                                                                Описание: <i>{{ data.item.caption }}</i>
                                                            <div v-show="data.item.discount_abbr === 'DiscountFixed'">
                                                                Скидка: <i>{{ data.item.discount_name }}</i>
                                                                <br>
                                                                Поле номер 1004: Сумма скидки от полной суммы начисления: <i>{{ data.item.discount_fixed_value }}</i>
                                                                <br>
                                                                Поле номер 1005: Количество дней предоcтавления скидки: <i>{{ data.item.discount_fixed_expiry_days }}</i>
                                                            </div>
                                                            <div v-show="data.item.discount_abbr === 'DiscountSize'">
                                                                Скидка: <i>{{ data.item.discount_name }}</i>
                                                                <br>
                                                                Поле номер 1006: Процент скидки от суммы начисления: <i>{{ data.item.discount_sice_value }}</i>
                                                                <br>
                                                                Поле номер 1007: Количество дней предоcтавления скидки: <i>{{ data.item.discount_sice_expiry_days }}</i>
                                                            </div>
                                                            <div v-show="data.item.discount_abbr === 'MultiplierSize'">
                                                                Скидка: <i>{{ data.item.discount_name }}</i>
                                                                <br>
                                                                Поле номер 1008: Коэффициент, понижающий размер начисления: <i>{{ data.item.multiplier_size_value }}</i>
                                                                <br>
                                                                Поле номер 1009: Количество дней предоcтавления скидки: <i>{{ data.item.multiplier_size_expiry_days }}</i>
                                                            </div>
                                                        </span>
                                                    </v-tooltip>
                                                </template>
                                                <template v-slot:item="data">
                                                    <v-list-item-content>
                                                        <div>{{ data.item.fullCaption }}</div>
                                                    </v-list-item-content>
                                                </template>
                                            </v-autocomplete>
                                        </v-flex>
                                        <v-flex xs12 sm8>
                                            <v-text-field
                                                    v-model.trim="charge.charge_status_reason"
                                                    type="text"
                                                    label="Основание изменения начисления"
                                                    :error-messages="requiredErrors('charge_status_reason')"
                                                    @blur="$v.charge.charge_status_reason.$touch()"
                                                    :disabled="this.charge.charge_condition!=1"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-card
                                                    v-if="isDiscount"
                                            >
                                                <v-card-title>
                                                    Скидка
                                                </v-card-title>
                                                <div
                                                        v-if="charge.discount"
                                                >
                                                    <v-card-text>
                                                        <h3>{{ getKBK(charge.kbk).discount_name }}</h3>
                                                    </v-card-text>
                                                    <v-card-text
                                                            v-if="getKBK(charge.kbk).discount_abbr=='DiscountFixed'"
                                                    >
                                                        <v-flex xs12 sm8>
                                                            <v-text-field
                                                                    v-model="charge.discount_fixed_value"
                                                                    type="number"
                                                                    label="Поле номер 1004: Сумма скидки от полной суммы начисления"
                                                                    readonly
                                                            ></v-text-field>
                                                        </v-flex>
                                                        <v-flex xs12 sm8>
                                                            <v-text-field
                                                                    v-model.trim="charge.discount_fixed_expiry"
                                                                    type="date"
                                                                    label="Поле номер 1005: Срок действия скидки"
                                                                    :disabled="this.charge.charge_condition!=1"
                                                            ></v-text-field>
                                                        </v-flex>
                                                    </v-card-text>
                                                    <v-card-text
                                                            v-if="getKBK(charge.kbk).discount_abbr=='DiscountSize'"
                                                    >
                                                        <v-flex xs12 sm8>
                                                            <v-text-field
                                                                    v-model="charge.discount_sice_value"
                                                                    type="number"
                                                                    label="Поле номер 1006: Процент скидки от суммы начисления"
                                                                    readonly
                                                            ></v-text-field>
                                                        </v-flex>
                                                        <v-flex xs12 sm8>
                                                            <v-text-field
                                                                    v-model.trim="charge.discount_sice_expiry"
                                                                    type="date"
                                                                    label="Поле номер 1007: Срок действия скидки"
                                                                    :disabled="this.charge.charge_condition!=1"
                                                            ></v-text-field>
                                                        </v-flex>
                                                    </v-card-text>
                                                    <v-card-text
                                                            v-if="getKBK(charge.kbk).discount_abbr=='MultiplierSize'"
                                                    >
                                                        <v-flex xs12 sm8>
                                                            <v-text-field
                                                                    v-model="charge.multiplier_size_value"
                                                                    type="number"
                                                                    label="Поле номер 1008: Коэффициент, понижающий размер начисления"
                                                                    readonly
                                                            ></v-text-field>
                                                        </v-flex>
                                                        <v-flex xs12 sm8>
                                                            <v-text-field
                                                                    v-model.trim="charge.multiplier_size_expiry"
                                                                    type="date"
                                                                    label="Поле номер 1009: Срок действия скидки"
                                                                    :disabled="this.charge.charge_condition!=1"
                                                            ></v-text-field>
                                                        </v-flex>
                                                    </v-card-text>
                                                </div>
                                                <v-card-actions
                                                        v-show="this.charge.charge_condition==1"
                                                >
                                                    <v-spacer></v-spacer>
                                                    <v-btn
                                                            icon
                                                            x-large
                                                            @click="addDiscount()"
                                                            v-show="charge.discount === null"
                                                    ><v-icon
                                                            x-large
                                                    >mdi-plus-circle</v-icon></v-btn>
                                                    <v-btn
                                                            icon
                                                            x-large
                                                            @click="charge.discount=null"
                                                            v-show="charge.discount !== null"
                                                    ><v-icon
                                                            x-large
                                                    >mdi-minus-circle</v-icon></v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-flex>
                                        <v-flex xs12>
                                            <div>
                                                <v-progress-linear
                                                        indeterminate
                                                        color="primary"
                                                        v-if="listLoading.includes('gis_gmpFetchChargeConditions')"
                                                ></v-progress-linear>
                                                <p><strong>УИН:</strong> {{charge.supplierBillID}}</p>
                                                <p><strong>Назначение платежа:</strong> {{charge.get_purpose}}</p>
                                                <p><strong>Состояние:</strong> {{ getChargeCondition(charge.charge_condition).condition }}</p>
                                                <p title="При переплате начисления принимает отрицательное значение; при полной оплате — значение «0»"><strong>Остаток суммы подлежащей оплате:</strong> {{ charge.amountToPay }}</p>
                                                <p><strong>Статус квитирования с платежами:</strong> {{ getAcknowledgmentStatus(charge.acknowledgmentStatus).name }}</p>
                                                <v-alert
                                                        type="error"
                                                        :value="errorGISGMP"
                                                        v-if="errorGISGMP"
                                                >
                                                    {{errorGISGMP}}
                                                </v-alert>
                                            </div>
                                        </v-flex>

                                    </v-layout>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-progress-linear
                                        indeterminate
                                        color="primary"
                                        v-if="listLoading.includes('gis_gmpinsertCharge_' + charge.id)"
                                ></v-progress-linear>
                            </v-card-actions>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                        @click.native="save(1)"
                                        v-show="([1, 2, 4, 5].includes(this.charge.charge_condition)) || (this.$route.params.charge_id == 'new')"
                                        :disabled="listLoading.includes('gis_gmpinsertCharge_' + charge.id)"
                                >Сохранить как черновик</v-btn>
                                <v-btn
                                        @click.native="save(2)"
                                        v-show="[1].includes(this.charge.charge_condition)"
                                        :disabled="listLoading.includes('gis_gmpinsertCharge_' + charge.id)"
                                >Сохранить и разрешить отправку</v-btn>
                                <v-btn
                                        v-if="(this.$route.params.charge_id !== 'new') && (this.charge.charge_status == 1) && [1].includes(this.charge.charge_condition)"
                                        @click.native="del"
                                        :disabled="listLoading.includes('gis_gmpinsertCharge_' + charge.id)"
                                >Удалить
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-tab-item>
                    <v-tab
                            href="#tab-2"
                            v-show="(this.charge.id !== null)"
                    >
                        Постановление
                    </v-tab>
                    <v-tab-item
                            :value="'tab-2'">
                        <v-card>
                            <v-card-text>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <v-flex xs6 sm2>
                                            <v-text-field
                                                    v-model.trim="charge.ruling_num"
                                                    type="text"
                                                    label="Номер"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs6 sm2>
                                            <v-text-field
                                                    v-model.trim="charge.ruling_date"
                                                    type="date"
                                                    label="Дата"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <!--{{charge}}-->
                                            <v-file-input
                                                    v-if="!ruling.ruling_filename"
                                                    accept="image/*, application/pdf"
                                                    label="Образ постановления"
                                                    show-size
                                                    v-model="ruling.ruling_path"
                                                    :error-messages="requiredRulingErrors('ruling_path')"
                                                    @blur="$v.ruling.ruling_path.$touch()"

                                            ></v-file-input>
                                            <div
                                                    v-if="charge.ruling_filename"
                                            >
                                                <b>Образ постановления:</b> {{charge.ruling_filename}}
                                                <v-btn
                                                        icon
                                                        color="indigo"
                                                        class="ml-3"
                                                        @click.native="downloadFile({urlFile: charge.ruling_path,
                                                                      filename: charge.ruling_filename
                                                                      })"
                                                >
                                                    <v-icon>mdi-cloud-download</v-icon>
                                                </v-btn>
                                                <v-btn
                                                        class="ml-3"
                                                        icon
                                                        color="indigo"
                                                        @click.native="deleteFile(charge.id, 'ruling')"
                                                ><v-icon>mdi-delete</v-icon></v-btn>
                                                <v-progress-circular
                                                        class="ml-3"
                                                        indeterminate
                                                        color="primary"
                                                        v-if="listLoading.includes('downloadFile_' + charge.ruling_path) || listLoading.includes('gis_gmpdeleteFile_' + charge.id + 'ruling')"
                                                ></v-progress-circular>
                                            </div>
                                        </v-flex>
                                        <v-flex xs12>
                                            <!--{{charge}}-->
                                            <v-file-input
                                                    v-if="!charge.ruling_sign_filename"
                                                    accept=".sig"
                                                    label="Файл подписи постановления"
                                                    show-size
                                                    v-model="charge.ruling_sign_path"
                                                    :error-messages="requiredRulingErrors('ruling_sign_path')"
                                                    @blur="$v.ruling.ruling_sign_path.$touch()"

                                            ></v-file-input>
                                            <div
                                                    v-if="charge.ruling_sign_filename"
                                            >
                                                <b>Файл подписи постановления:</b> {{charge.ruling_sign_filename}}
                                                <v-btn
                                                        icon
                                                        color="indigo"
                                                        class="ml-3"
                                                        @click.native="downloadFile({urlFile: charge.ruling_sign_path,
                                                                      filename: charge.ruling_sign_filename
                                                                      })"
                                                >
                                                    <v-icon>mdi-cloud-download</v-icon>
                                                </v-btn>
                                                <v-btn
                                                        class="ml-3"
                                                        icon
                                                        color="indigo"
                                                        @click.native="deleteFile(charge.id, 'ruling_sign')"
                                                ><v-icon>mdi-delete</v-icon></v-btn>
                                                <v-progress-circular
                                                        class="ml-3"
                                                        indeterminate
                                                        color="primary"
                                                        v-if="listLoading.includes('downloadFile_' + charge.ruling_sign_path) || listLoading.includes('gis_gmpdeleteFile_' + charge.id + 'ruling_sign')"
                                                ></v-progress-circular>
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                            @click.native="saveFile()"
                                    >Сохранить</v-btn>
                                </v-card-actions>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab
                            href="#tab-5"
                    >
                        Ручное квитирование
                    </v-tab>
                    <v-tab-item
                            :value="'tab-5'"
                    >
                        <list-forced-acknowledgement
                                :charge_id="charge.id"
                        ></list-forced-acknowledgement>
                    </v-tab-item>
                    <v-tab href="#tab-3">
                        Системные данные
                    </v-tab>
                    <v-tab-item
                            :value="'tab-3'">
                        <system-form :system-info=charge></system-form>
                    </v-tab-item>
                </v-tabs>
                <v-card-actions>
                    <v-btn
                            :href="urlQuittance(this.$route.params.charge_id)"
                            target="_blank"
                            v-show="(this.$route.params.charge_id !== 'new')"
                    >Квитанция</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            @click.native="cancel"
                            :disabled="listLoading.includes('gis_gmpinsertCharge_' + charge.id)"
                    >Список
                    </v-btn>
                </v-card-actions>
            </v-flex>
            <router-view></router-view>
        </v-layout>
    </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'
import listForcedAcknowledgement from './forcedAcknowledgement/list'
import SystemForm from '../../common/systemForm'

const maxSizeFile = (size) =>
  (value) => {
    if (value && (typeof value === 'object')) {
      return value.size < size
    }
    return true
  }
// function validatorRusDigit (word) {
//   if (word === '') {
//     return true
//   }
//   return /^[А-Яа-яЁё0-9 №()'.,-/]+$/.test(word)
// }

export default {
  components: { SystemForm, listForcedAcknowledgement },
  data () {
    return {
    }
  },
  mixins: [validationMixin],
  validations () {
    if (this.charge.charge_status === 1) {
      return {
        charge: {
          totalAmount: { required },
          // purpose: { required, validatorRusDigit },
          charge_status_reason: { maxLength: maxLength(0) }
        },
        ruling: {
          ruling_path: { maxSizeFile: maxSizeFile(2000000) },
          ruling_sign_path: { maxSizeFile: maxSizeFile(10000) }
        }
      }
    } else {
      return {
        charge: {
          totalAmount: { required },
          // purpose: { required, validatorRusDigit },
          charge_status_reason: { required }
        },
        ruling: {
          ruling_path: { maxSizeFile: maxSizeFile(2000000) },
          ruling_sign_path: { maxSizeFile: maxSizeFile(10000) }
        }
      }
    }
  },
  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    },
    charge () {
      return this.$store.getters['gis_gmpCharge/charge']
    },
    ruling () {
      // Дублирует charge
      // Это нужно для раздельной валидации
      return this.$store.getters['gis_gmpCharge/charge']
    },
    formTitle () {
      return this.$route.params.service_id === 'new' ? 'Добавить начисление' : 'Начисление'
    },
    chargeStatuses () {
      return this.$store.getters['gis_gmpCharge/chargeStatuses']
    },
    chargeConditions () {
      return this.$store.getters['gis_gmpCharge/chargeConditions']
    },
    kbk () {
      return this.$store.getters['gis_gmpCharge/kbk']
    },
    isDiscount () {
      if (!(this.charge.kbk === null)) {
        return 'discount_abbr' in this.getKBK(this.charge.kbk)
      } else {
        return false
      }
    },
    errorGISGMP () {
      let charge = this.$store.getters['gis_gmpCharge/charge']
      if (charge.charge_condition === 5) {
        try {
          return charge.prepare_charge.response_data.ImportProtocol.description
        } catch (e) {
          return ''
        }
      } else {
        return ''
      }
    },
    tab: {
      get () {
        return this.$store.getters['gis_gmpCharge/tab']
      },
      set (value) {
        return this.$store.commit(
          'gis_gmpCharge/setTab',
          value)
      }
    }
  },
  watch: {
    pagination: {
      handler () {
        this.initialize()
      },
      deep: true
    }
  },
  methods: {
    initialize () {
      let id = this.$route.params.charge_id
      if (id === 'new') {
        this.$store.commit('gis_gmpCharge/setDefaultCharge')
      } else {
        this.$store.dispatch('gis_gmpCharge/fetchCharge', {
          id: id
        })
      }
    },
    save (chargeConditionId) {
      this.$v.charge.$touch()
      if (!this.$v.charge.$invalid) {
        this.$set(this.charge, 'payer', this.$route.params.payer_id)
        this.$set(this.charge, 'charge_condition', chargeConditionId)
        this.$store.dispatch('gis_gmpCharge/insertCharge', this.charge)
          .then(() => {
            if (this.$route.params.charge_id === 'new') {
              this.$router.push({
                name: 'gis_gmp_charge',
                params: {
                  'payer_id': this.$route.params.payer_id,
                  'charge_id': this.charge.id
                }
              })
            }
          }
          )
      }
    },
    saveFile () {
      this.$v.ruling.$touch()
      if (!this.$v.ruling.$invalid) {
        this.$store.dispatch('gis_gmpCharge/insertFileCharge', this.ruling)
      }
    },
    del () {
      if (this.charge.id !== 'new') {
        this.$store.dispatch('gis_gmpCharge/deleteCharge', this.charge.id)
          .then(() => {
            this.cancel()
          })
      }
    },
    deleteFile: function (id, fileType) {
      if (this.charge.id !== 'new') {
        this.$store.dispatch('gis_gmpCharge/deleteFile',
          { id: id,
            fileType: fileType })
      }
    },
    cancel () {
      this.$router.push({ name: 'gis_gmp_charges',
        params: {
          'payer_id': this.$route.params.payer_id
        } })
    },
    requiredErrors (fieldName) {
      const errors = []
      const field = this.$v.charge[fieldName]
      if (!field.$dirty) return errors
      if (field.hasOwnProperty('required')) {
        !field.required && errors.push('Обязательное поле')
      }
      if (field.hasOwnProperty('email')) {
        !field.email && errors.push('Это не адрес электронной почты')
      }
      if (field.hasOwnProperty('validatorRus')) {
        !field.validatorRus && errors.push('Некорректные символы')
      }
      if (field.hasOwnProperty('validatorRusDigit')) {
        !field.validatorRusDigit && errors.push('Некорректные символы')
      }
      if (field.hasOwnProperty('validatorPhone')) {
        !field.validatorPhone && errors.push('Некорректные символы')
      }
      if (field.hasOwnProperty('maxLength')) {
        !field.maxLength && errors.push('Поле должно быть пустым')
      }
      return errors
    },
    requiredRulingErrors (fieldName) {
      const errors = []
      const field = this.$v.ruling[fieldName]
      if (!field.$dirty) return errors
      if (field.hasOwnProperty('required')) {
        !field.required && errors.push('Обязательное поле')
      }
      if (field.hasOwnProperty('maxSizeFile') && (fieldName === 'ruling_path')) {
        !field.maxSizeFile && errors.push('Размер файла не должен превышать 2 Мбайт')
      }
      if (field.hasOwnProperty('maxSizeFile') && (fieldName === 'ruling_sign_path')) {
        !field.maxSizeFile && errors.push('Размер файла не должен превышать 10 Кбайт')
      }
      return errors
    },
    getChargeCondition (conditionId) {
      return this.$store.getters['gis_gmpCharge/getChargeCondition'](conditionId)
    },
    getAcknowledgmentStatus (id) {
      return this.$store.getters['gis_gmpCharge/getAcknowledgmentStatus'](id)
    },
    urlQuittance (id) {
      return this.$store.getters['gis_gmpCharge/urlQuittance'](id)
    },
    downloadFile (link) {
      this.$store.dispatch('common/downloadFile', link)
    },
    getKBK (id) {
      return this.$store.getters['gis_gmpCharge/getKBK'](id)
    },
    addDiscount () {
      const currentKBK = this.getKBK(this.charge.kbk)
      this.charge.discount = currentKBK.discount
      let dateDiscount = new Date()
      if ('date_created' in this.charge) {
        dateDiscount = new Date(this.charge.date_created.slice(0, 10))
      }
      if (currentKBK.discount_abbr === 'DiscountFixed') {
        this.charge.discount_fixed_value = this.getKBK(this.charge.kbk).discount_fixed_value
        dateDiscount.setDate(dateDiscount.getDate() + this.getKBK(this.charge.kbk).discount_fixed_expiry_days)
        this.charge.discount_fixed_expiry = dateDiscount.toISOString().slice(0, 10)
      }
      if (currentKBK.discount_abbr === 'DiscountSize') {
        this.charge.discount_sice_value = this.getKBK(this.charge.kbk).discount_sice_value
        dateDiscount.setDate(dateDiscount.getDate() + this.getKBK(this.charge.kbk).discount_sice_expiry_days)
        this.charge.discount_sice_expiry = dateDiscount.toISOString().slice(0, 10)
      }
      if (currentKBK.discount_abbr === 'MultiplierSize') {
        this.charge.multiplier_size_value = this.getKBK(this.charge.kbk).multiplier_size_value
        dateDiscount.setDate(dateDiscount.getDate() + this.getKBK(this.charge.kbk).multiplier_size_expiry_days)
        this.charge.multiplier_size_expiry = dateDiscount.toISOString().slice(0, 10)
      }
    }
  },
  created: function () {
    this.initialize()
  }
}
</script>
<style scoped>
    td, th {
        text-align: left;
        padding: 5px;
    }

    th {
        vertical-align: top
    }

    .bloc_inline {
        display: inline-block;
    }
</style>
